import React from 'react'
const Tick = () => {
    return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill="#fff" d="M0 0h24v24H0z"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M20.423 5.576a.6.6 0 0 1 0 .848l-11 11a.6.6 0 0 1-.848 0l-5-5a.6.6 0 1 1 .848-.848L9 16.15 19.575 5.576a.6.6 0 0 1 .848 0" fill="#1A1A1A"/>
    </svg>
)
}
export default Tick